import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphEdge } from "../model/NodeGraphEdge";
import { NodeGraphEvent } from "./NodeGraphEvent";
import { NodeGraphInteraction } from "./NodeGraphInteraction";

export class NGHoverEdges extends NodeGraphInteraction
{
  _hoveredEdge:NodeGraphEdge;

  constructor( ng:NodeGraph )
  {
    super( ng );
  }

  getEdge( nge: NodeGraphEvent ) 
  {
    let hoveredReference = nge.hoveredReference;    

    if ( ! hoveredReference )
    {
      return this._nodeGraph.getClosestEdge( nge.localMousePosition );
    }

    if ( ! isClassOf( hoveredReference.reference, NodeGraphEdge ) )
    {
      return null;
    }

    return hoveredReference.reference as NodeGraphEdge;
   
    
  }

  update( nge: NodeGraphEvent ) 
  {
    let edge = this.getEdge( nge )

    if ( this._hoveredEdge === edge )
    {
      return;
    }

    let beforeHovered = this._hoveredEdge;
    this._hoveredEdge = null;

    if ( beforeHovered )
    {
      beforeHovered.setHoverState( false );
    }

    this._hoveredEdge = edge;

    if ( this._hoveredEdge )
    {
      this._hoveredEdge.setHoverState( true );
    }

    this._nodeGraph._ui.updateEdges();

    
  }
}